(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-colors-famillies"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('peintagone-family-explorer')) {
  class PeintagoneFamilyExplorer extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.renderedPath = this.cleanPath(this.dataset.renderedPath || window.location.pathname);
      this.cards = Array.from(this.querySelectorAll('.pcf__card'));
      this.familyInputs = Array.from(this.querySelectorAll('[data-pcf-family]'));
      this.styleInputs = Array.from(this.querySelectorAll('[data-pcf-style]'));
      this.familyData = JSON.parse(this.querySelector('[data-pcf-family-data]').textContent);
      this.families = new Map(this.familyInputs.map(input => [input.value, {
        handle: input.value,
        label: input.dataset.label,
        description: input.dataset.description || '',
        url: input.dataset.url,
        ids: new Set((this.familyData[input.value] || []).map(String))
      }]));
      this.collections = new Map(Array.from(this.querySelector('[data-pcf-collections]').content.children).map(item => [item.dataset.handle, {
        handle: item.dataset.handle,
        label: item.dataset.label,
        description: item.dataset.description || '',
        url: item.dataset.url,
        all: item.dataset.all === 'true'
      }]));
      this.allCollection = Array.from(this.collections.values()).find(item => item.all);
      this.collectionHandle = this.dataset.defaultCollection || this.allCollection?.handle;
      this.search = this.querySelector('[data-pcf-search]');
      this.active = this.querySelector('[data-pcf-active]');
      this.drawer = this.querySelector('[data-pcf-dialog]');
      this.filters = this.querySelector('[data-pcf-filters]');
      this.media = window.matchMedia('(max-width: 749px)');
      this.querySelector('[data-pcf-open]').addEventListener('click', () => this.drawer.showModal(), { signal });
      this.querySelectorAll('[data-pcf-close]').forEach(button => button.addEventListener('click', () => this.drawer.close(), { signal }));
      this.drawer.addEventListener('click', event => {
        if (event.target !== this.drawer) return;
        const rect = this.drawer.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.drawer.close();
      }, { signal });
      this.addEventListener('change', event => {
        if (event.target.matches('[data-pcf-family], [data-pcf-style]')) this.commit();
      }, { signal });
      this.addEventListener('click', event => this.followLink(event), { signal });
      this.search.addEventListener('input', () => {
        window.clearTimeout(this.searchTimer);
        if (this.cleanPath(this.buildURL().pathname) === this.renderedPath) this.apply();
        else this.navigationRequest?.abort();
        this.searchTimer = window.setTimeout(() => this.commit({ replace: true }), 250);
      }, { signal });
      this.querySelector('[data-pcf-clear]').addEventListener('click', () => {
        this.familyInputs.forEach(input => { input.checked = false; });
        this.styleInputs.forEach(input => { input.checked = false; });
        this.search.value = '';
        this.commit();
      }, { signal });
      window.addEventListener('popstate', () => {
        window.clearTimeout(this.searchTimer);
        const url = new URL(window.location.href);
        if (this.cleanPath(url.pathname) !== this.renderedPath) this.navigate(url, { mode: 'none' });
        else {
          this.navigationRequest?.abort();
          this.readURL(url);
          const target = this.buildURL();
          if (this.cleanPath(target.pathname) !== this.renderedPath) this.navigate(target, { mode: 'replace' });
          else this.apply();
        }
      }, { signal });
      this.media.addEventListener('change', () => this.positionFilters(), { signal });
      this.positionFilters();
      this.readURL(new URL(window.location.href));
      this.classList.add('pcf--ready');
      const target = this.buildURL();
      if (this.cleanPath(target.pathname) !== this.renderedPath) this.navigate(target, { mode: 'replace' });
      else {
        this.apply();
        if (target.href !== window.location.href) this.saveHistory(target, 'replace');
      }
    }

    disconnectedCallback() {
      window.clearTimeout(this.searchTimer);
      this.navigationRequest?.abort();
      this.controller?.abort();
      this.controller = null;
      this.drawer?.close();
    }

    cleanPath(path) { return path.replace(/\/+$/, '') || '/'; }

    positionFilters() {
      if (!this.media.matches) this.drawer.close();
      this.querySelector(this.media.matches ? '[data-pcf-mobile]' : '[data-pcf-desktop]').append(this.filters);
    }

    selected(inputs) { return inputs.filter(input => input.checked).map(input => input.value); }

    readURL(url) {
      const params = url.searchParams;
      const requested = params.has('family') ? params.get('family') : params.has('filters') ? params.get('filters') : this.dataset.defaultFamily;
      const families = new Set((requested || '').split(',').filter(handle => this.families.has(handle)));
      const styles = new Set((params.get('styles_and_atmospheres') || '').split(','));
      const collection = params.get('collection') || this.dataset.defaultCollection || this.allCollection?.handle;
      this.collectionHandle = this.collections.has(collection) ? collection : this.allCollection?.handle;
      this.familyInputs.forEach(input => { input.checked = families.has(input.value); });
      this.styleInputs.forEach(input => { input.checked = styles.has(input.value); });
      this.search.value = params.get('q') || '';
    }

    pageContext() {
      const families = this.selected(this.familyInputs).map(handle => this.families.get(handle));
      const collection = this.collections.get(this.collectionHandle) || this.allCollection;
      const singleFamilyPage = Boolean(collection?.all && families.length === 1);
      return { families, collection, singleFamilyPage, primary: singleFamilyPage ? families[0] : collection };
    }

    buildURL() {
      const context = this.pageContext();
      const url = new URL(context.primary?.url || window.location.pathname, window.location.origin);
      const current = new URL(window.location.href);
      const managed = new Set(['family', 'collection', 'filters', 'filters_logic', 'styles_and_atmospheres', 'q', 'page', 'section_id', 'sections']);
      for (const [key, value] of current.searchParams) if (!managed.has(key)) url.searchParams.append(key, value);
      if (!context.singleFamilyPage && context.families.length) {
        url.searchParams.set('filters', context.families.map(family => family.handle).join(','));
        if (context.families.length > 1) url.searchParams.set('filters_logic', 'OR');
      }
      const styles = this.selected(this.styleInputs);
      if (styles.length) url.searchParams.set('styles_and_atmospheres', styles.join(','));
      if (this.search.value.trim()) url.searchParams.set('q', this.search.value.trim());
      return url;
    }

    saveHistory(url, mode) {
      if (mode === 'none' || url.href === window.location.href) return;
      history[mode === 'replace' ? 'replaceState' : 'pushState']({ ...(history.state || {}), peintagoneColours: true }, '', url);
    }

    commit({ replace = false } = {}) {
      window.clearTimeout(this.searchTimer);
      const url = this.buildURL();
      if (this.cleanPath(url.pathname) !== this.renderedPath) {
        this.navigate(url, { mode: replace ? 'replace' : 'push' });
        return;
      }
      this.navigationRequest?.abort();
      this.removeAttribute('aria-busy');
      this.saveHistory(url, replace ? 'replace' : 'push');
      this.apply();
    }

    followLink(event) {
      const link = event.target.closest('a[data-pcf-navigation]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      const handle = link.dataset.handle;
      if (link.dataset.pcfNavigation === 'collection') {
        if (!this.collections.has(handle)) return;
        this.collectionHandle = handle;
      } else {
        if (!this.families.has(handle)) return;
        this.familyInputs.forEach(input => { input.checked = input.value === handle; });
      }
      event.preventDefault();
      this.commit();
    }

    normalize(value) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); }

    apply() {
      const context = this.pageContext();
      const styles = this.selected(this.styleInputs);
      const query = this.normalize(this.search.value.trim());
      let count = 0;
      for (const card of this.cards) {
        const id = String(card.dataset.colorId);
        const inFamily = !context.families.length || context.families.some(family => family.ids.has(id));
        const inCollection = context.collection?.all || card.dataset.colorCollections.split(',').includes(context.collection?.handle);
        const inStyle = !styles.length || styles.some(style => card.dataset.colorStylesAndAtmospheres.split(',').includes(style));
        const inSearch = !query || this.normalize(`${card.dataset.colorName} ${card.dataset.colorRef}`).includes(query);
        card.hidden = !(inFamily && inCollection && inStyle && inSearch);
        if (!card.hidden) count++;
      }
      const countText = count === 1 ? this.dataset.countOne : this.dataset.countOther.replace('999', new Intl.NumberFormat(document.documentElement.lang || 'en').format(count));
      this.querySelectorAll('[data-pcf-count]').forEach(element => { element.textContent = countText; });
      this.querySelector('[data-pcf-empty]').hidden = count > 0;
      this.updateEditorial(context);
      this.renderActiveFilters();
      this.updateNavigation(context);
    }

    updateEditorial(context = this.pageContext()) {
      const intro = this.querySelector('[data-pcf-intro]');
      const primary = this.querySelector('[data-pcf-primary]');
      if (primary && context.primary) {
        primary.querySelector('[data-pcf-primary-title]').textContent = context.primary.label;
        primary.querySelector('[data-pcf-primary-description]').innerHTML = context.primary.description;
      }
      const secondary = this.querySelector('[data-pcf-secondary]');
      secondary.hidden = context.singleFamilyPage || !context.families.length;
      if (!secondary.hidden) {
        secondary.querySelector('[data-pcf-secondary-title]').textContent = context.families.length === 1 ? context.families[0].label : this.dataset.multipleHeading;
        secondary.querySelector('[data-pcf-secondary-description]').innerHTML = context.families.length === 1 ? context.families[0].description : '';
      }
      intro.hidden = !primary && secondary.hidden;
    }

    renderActiveFilters() {
      this.active.replaceChildren();
      const appendChip = (label, clear) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pcf__chip';
        button.textContent = `${label} ×`;
        button.setAttribute('aria-label', `${this.dataset.clearLabel}: ${label}`);
        button.addEventListener('click', () => { clear(); this.commit(); this.search.focus({ preventScroll: true }); }, { once: true });
        this.active.append(button);
      };
      for (const input of [...this.familyInputs, ...this.styleInputs]) if (input.checked) appendChip(input.dataset.label, () => { input.checked = false; });
      if (this.search.value.trim()) appendChip(this.search.value.trim(), () => { this.search.value = ''; });
      this.active.hidden = !this.active.children.length;
    }

    updateNavigation(context = this.pageContext()) {
      this.querySelectorAll('[data-pcf-navigation]').forEach(link => {
        const selected = link.dataset.pcfNavigation === 'collection' ? link.dataset.handle === context.collection?.handle : context.families.length === 1 && link.dataset.handle === context.families[0].handle;
        link.dataset.active = String(selected);
        if (this.cleanPath(new URL(link.href, window.location.origin).pathname) === this.cleanPath(window.location.pathname)) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }

    focusSnapshot() {
      const element = document.activeElement;
      if (!element || !this.contains(element)) return null;
      if (element.matches('[data-pcf-family]')) return { selector: '[data-pcf-family]', value: element.value };
      if (element.matches('[data-pcf-style]')) return { selector: '[data-pcf-style]', value: element.value };
      if (element.matches('[data-pcf-search]')) return { selector: '[data-pcf-search]' };
      if (element.matches('[data-pcf-navigation]')) return { selector: '[data-pcf-navigation]', value: element.dataset.handle };
      return null;
    }

    nativeNavigation(url, mode) {
      if (mode === 'none') window.location.reload();
      else if (mode === 'replace') window.location.replace(url.href);
      else window.location.assign(url.href);
    }

    async ensureStyles(nextDocument) {
      const existing = new Set(Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map(link => link.href));
      const missing = Array.from(nextDocument.querySelectorAll('link[rel="stylesheet"]')).filter(link => !existing.has(link.href));
      await Promise.all(missing.map(source => new Promise((resolve, reject) => {
        const link = document.importNode(source, true);
        const timer = window.setTimeout(() => { link.remove(); reject(new Error('Stylesheet timeout')); }, 5000);
        link.addEventListener('load', () => { window.clearTimeout(timer); resolve(); }, { once: true });
        link.addEventListener('error', () => { window.clearTimeout(timer); link.remove(); reject(new Error('Stylesheet unavailable')); }, { once: true });
        document.head.append(link);
      })));
    }

    compatibleScripts(nextDocument, nextMain) {
      const existing = new Set(Array.from(document.querySelectorAll('script[src]')).map(script => script.src));
      const required = [...nextMain.querySelectorAll('script[src]'), ...nextDocument.head.querySelectorAll('script[src*="/compiled_assets/"]')];
      if (required.some(script => !existing.has(script.src))) return false;
      return !Array.from(nextMain.querySelectorAll('script:not([src])')).some(script => {
        const type = script.getAttribute('type') || 'text/javascript';
        return ['text/javascript', 'application/javascript', 'module'].includes(type) && script.textContent.trim();
      });
    }

    syncHead(nextDocument) {
      document.title = nextDocument.title;
      const selectors = ['meta[name="description"]', 'meta[name="robots"]', 'link[rel="canonical"]', 'link[rel="alternate"][hreflang]', 'meta[property^="og:"]', 'meta[name^="twitter:"]'];
      for (const selector of selectors) {
        document.head.querySelectorAll(selector).forEach(element => element.remove());
        nextDocument.head.querySelectorAll(selector).forEach(element => document.head.append(document.importNode(element, true)));
      }
    }

    async navigate(url, { mode = 'push' } = {}) {
      this.navigationRequest?.abort();
      if (this.dataset.ajax !== 'true' || window.Shopify?.designMode || url.origin !== window.location.origin) {
        this.nativeNavigation(url, mode);
        return;
      }
      const request = new AbortController();
      this.navigationRequest = request;
      const focus = this.focusSnapshot();
      const drawerOpen = this.drawer.open;
      const top = this.getBoundingClientRect().top;
      this.setAttribute('aria-busy', 'true');
      this.querySelectorAll('[data-pcf-count]').forEach(element => { element.textContent = this.dataset.loadingLabel; });
      try {
        const response = await fetch(url.href, { signal: request.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok || !response.headers.get('content-type')?.includes('text/html')) throw new Error('Page unavailable');
        if (response.url && new URL(response.url).origin !== window.location.origin) throw new Error('Different origin');
        const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextMain = nextDocument.getElementById('MainContent');
        const main = this.closest('#MainContent');
        const nextExplorer = nextMain?.querySelector('peintagone-family-explorer[data-pcf-version="2"]');
        if (!main || !nextExplorer || nextDocument.documentElement.lang !== document.documentElement.lang || !this.compatibleScripts(nextDocument, nextMain)) throw new Error('Full navigation required');
        await this.ensureStyles(nextDocument);
        if (request.signal.aborted || !this.isConnected) return;
        const render = () => {
          if (request.signal.aborted || !this.isConnected) return;
          this.saveHistory(url, mode);
          this.syncHead(nextDocument);
          for (const attribute of Array.from(main.attributes)) if (!nextMain.hasAttribute(attribute.name)) main.removeAttribute(attribute.name);
          for (const attribute of Array.from(nextMain.attributes)) main.setAttribute(attribute.name, attribute.value);
          main.replaceChildren(...Array.from(nextMain.childNodes).map(node => document.importNode(node, true)));
          document.querySelectorAll('form[action*="/localization"] input[name="return_to"]').forEach(input => { input.value = url.pathname + url.search; });
          const explorer = main.querySelector('peintagone-family-explorer');
          if (explorer) {
            if (drawerOpen && explorer.media?.matches) explorer.drawer.showModal();
            if (mode !== 'none') window.scrollBy(0, explorer.getBoundingClientRect().top - top);
            if (focus) {
              const element = Array.from(explorer.querySelectorAll(focus.selector)).find(item => !focus.value || (item.value || item.dataset.handle) === focus.value);
              element?.focus({ preventScroll: true });
            }
          }
          document.dispatchEvent(new CustomEvent('peintagone:colour-navigation', { detail: { url: url.href, title: document.title } }));
        };
        if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const transition = document.startViewTransition(render);
          transition.finished.catch(() => {});
          await transition.updateCallbackDone;
        } else render();
      } catch (error) {
        if (request.signal.aborted || !this.isConnected) return;
        this.nativeNavigation(url, mode);
      } finally {
        if (this.navigationRequest === request && this.isConnected) {
          this.navigationRequest = null;
          this.removeAttribute('aria-busy');
        }
      }
    }
  }
  customElements.define('peintagone-family-explorer', PeintagoneFamilyExplorer);
}

  } catch(e) { console.error(e); }
})();
})();
